<script lang="ts">
	import Button from "@components/common/Button.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Icon from "@components/common/Icon.svelte";
	import { getContext } from "svelte";
	import inquiryIcon from "@core/assets/icons/inquiry.svg?raw";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import type { ContentType } from "@core/schema/ContentType.js";
	import type { ContentBlockComponentProps } from "./ContentBlockComponentProps.js";

	const { data, align = "center" }: ContentBlockComponentProps<ContentType.ContactButton> = $props();
	const openInquiryForm = getContext("openInquiryForm");

	if (typeof openInquiryForm !== "function") {
		throw new Error("Invalid context: openInquiryForm should be a function.");
	}
</script>

<Button
	variant={ButtonVariant.Primary}
	class={["w-fit", align === "center" ? "mx-auto" : "mx-0"]}
	onclick={(): void => {
		openInquiryForm();
	}}
>
	<Formatted text={data.text} />
	{#snippet icon()}
		<Icon icon={inquiryIcon} class="size-5 md:size-8" />
	{/snippet}
</Button>
